import { Model } from './model';
import { File as FileModel } from './file';
import { TipoTemplate } from './tipo-template';
import { Compagnia } from './compagnia';
import { Studio } from './studio';
import { Ramo } from './ramo';
import { StatoIncarico } from './stato-incarico';

export class Template extends Model {
  static apiUrl: string = "templates";

  nome: string;
  descrizione: string;

  files: FileModel[];

  tipo_template: TipoTemplate;
  tipo_template_id: number;

  ramo: Ramo;
  ramo_id: number;

  compagnia: Compagnia;
  compagnia_id: number;

  studio: Studio;
  studio_id: number;
  stato_incarico: StatoIncarico;
  doc_default_text: string;

  url: string;

  deserialize(input: any): Template {
    let retV: Template = new Template();
    retV = super.deserialize(input) as Template;

    if (input?.tipo_template) {
      retV.tipo_template = new TipoTemplate().deserialize(input.tipo_template);
    }
    if (input?.stato_incarico) {
      retV.stato_incarico = new StatoIncarico().deserialize(input.stato_incarico);
    }
    if (input?.ramo) {
      retV.ramo = new Ramo().deserialize(input.ramo);
    }
    if (input?.studio) {
      retV.studio = new Studio().deserialize(input.studio);
    }
    if (input?.compagnia) {
      retV.compagnia = new Compagnia().deserialize(input.compagnia);
    }
    if (input?.files) {
      retV.files = input.files.map(f => new FileModel().deserialize(f));
    }

    return retV;
  }

}
